// #region Imports
import { defineComponent } from "vue";
import DxColorBox from 'devextreme-vue/color-box';
// #endregion
// #region Konstanten
// #endregion
// #region Core
export default defineComponent({
    name: 'g-color-edit',
    components: {
        DxColorBox
    },
    props: {
        modelValue: {
            type: String,
            required: false,
        },
        placeholder: {
            type: String,
            required: false,
            default: ''
        },
        formFieldName: {
            type: String,
            required: true,
            default: ''
        }
    },
    methods: {
        onChange(event) {
            this.$emit('update:modelValue', event.value);
        },
        restoreInheritance() {
            this.$emit('update:modelValue', null);
        },
    }
});
// #endregion
